module.exports = __webpack_public_path__ + "img/technologies.153baae6.svg";